import React from "react";

import dscLogo from "../../assets/Logo/GDG logo.jpeg";
import dscLogoDark from "../../assets/Logo/GDG logo dark.png";
import classes from "./Logo.module.css";
import classesDark from "./LogoDark.module.css";

const Logo = ({ theme }) => {
  if (!theme) {
    return (
      <img className={classesDark.Logo} src={dscLogoDark} alt="DSC_DARK" />
    );
  }
  return <img className={classes.Logo} src={dscLogo} alt="DSC-logo" />;
};

export default Logo;
